var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoublecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833374 12.014L5.73342 15.9814L13.6016 6.44226L12.0457 5L5.45035 12.996L2.0855 10.2715L0.833374 12.014ZM19.1667 6.44226L17.6108 5L11.031 12.9774L10.253 12.3176L8.96163 14.0295L11.283 16L19.1667 6.44226Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublecheck);
export default __webpack_public_path__ + "34ed0d782df251f6a47b59a84ceb6dde.svg";
export { ForwardRef as ReactComponent };